@if (showMessage && notification) {
  <div
    class="notification"
    [class.notification--success]="notification.type == NotificationType.success"
    [class.notification--error]="notification.type == NotificationType.error"
    [class.notification--warning]="notification.type === NotificationType.warning"
    [@openClose]="showMessage ? 'open' : 'close'"
    >
    <div class="notification__wrap" >
      @if (notification.type == NotificationType.success) {
        <mat-icon class="icon-48" svgIcon="success"></mat-icon>
      }
      @if (notification.type == NotificationType.warning) {
        <mat-icon class="icon-48" svgIcon="warning"></mat-icon>
      }
      @if (notification.type == NotificationType.error) {
        <mat-icon class="icon-48" svgIcon="error"></mat-icon>
      }
      <span class="notification__text">{{ notification.text }}</span>
      <div>
        <button type="button" (click)="dismiss(true)" mat-flat-button color="accent" title="notification.button">
          {{ notification.button }}
        </button>
      </div>
      <button type="button" (click)="dismiss(true)" class="btn-icon" title="Luk">
        <mat-icon svgIcon="close" class="icon-32"></mat-icon>
      </button>
    </div>
  </div>
}
